<template>
  <div>
    <st_header_cop></st_header_cop>
    <div class="index_page contanic_no_lock">
      <!--资料下载-->
      <br>
      <el-card class="box-card page_card">
        <!-- 导航 -->
        <el-menu
          :default-active="'1'"
          text-color="#333333"
          active-text-color="#E71489"
          class="el-menu-demo menu-div"
          mode="horizontal"
          @select="handleSelect">
          <el-menu-item index="1">软件文件</el-menu-item>
          <el-menu-item index="2">赛事资料</el-menu-item>
          <el-menu-item index="3">产品资料</el-menu-item>
        </el-menu>
        <!-- 条目 -->
        <div class="item_div" v-for="item in dataList" :key="item.id">
          <label class="left_div">{{item.down_name}}</label>
          <label class="right_div"><a :href="item.down_url" target="_black">下载</a></label>
        </div>

        

        <br>
        <!-- 分页器 -->
        <el-pagination
          layout="prev, pager, next"
          :total="pagination.total"
          :page-size="pagination.size"
          :hide-on-single-page="true"
          @current-change="handleCurrentChange">
        </el-pagination>
      </el-card>


    </div>
    <st_footer_cop
      :active-index="'4'"
      :is_lock_infeed="false">
    </st_footer_cop>
  </div>
</template>

<script>
import st_header from '../components/header_main.vue'
import st_footer from '../components/footer.vue'
import { getDownPage } from '../utils/api'

export default {
  name: 'means',
  components: {
    st_header_cop: st_header,
    st_footer_cop: st_footer,
  },
  data() {
    return {
      dataList:[],
      selIndex:"软件文件",
      pagination:{    //分页数据
        page:1,
        size:15,
        total:1
      }
    };
  },
  methods: {
    handleSelect (key, keyPath) {
      if (key == '1') {  //软件文件
        this.selIndex = "软件文件"
      } else if (key == '2') {   //赛事资料
        this.selIndex = "赛事资料"
      } else if (key == '3') {   //产品资料
        this.selIndex = "产品资料"
      }
      this.getData(1)
    },
    //点击分页再次请求
    handleCurrentChange(val) {
      this.getData(val);
    },
    getData(pageIds){
      let that = this;
      that.load.$emit('loading', true);
      getDownPage({"down_type":that.selIndex,"page":pageIds,"size":15})
      .then(function(res){
        if(res.code===1000){
          that.dataList = res.data.list
          that.pagination = res.data.pagination
          setTimeout(function(){
            that.load.$emit('loading', false);
          },1000)
        }else{
          console.error("error")
        }
      }).catch(function(err){
        console.log(err)
      })
    }
  },
  created(){
    this.getData(1)
  }
}
</script>

<style scoped lang="scss">

/deep/
.el-pagination {
    white-space: nowrap;
    padding: 2px 5px;
    color: #303133;
    font-weight: 700;
    text-align: right;
}
/deep/
.el-pagination button:disabled {
    color: #C0C4CC;
    background-color: rgba(255,255,255,0);
    cursor: not-allowed;
}

/deep/
.el-pagination button {
    color: #C0C4CC;
    background-color: rgba(255,255,255,0);
    cursor: not-allowed;
}

/deep/
.el-pagination .btn-next, .el-pagination .btn-prev {
    background: rgba(255,255,255,0);
    background-size: 16px;
    cursor: pointer;
    margin: 0;
    color: #C0C4CC;
}

/deep/
.el-pager li {
    background: rgba(255,255,255,0);
    color:#111;
    font-size:18px
}

/deep/
.el-pager li.active {
    color: #E71489;
    cursor: default;
    font-size:20px
}

.page_card{
  min-height: 65vh;
}

.index_page {
  background: rgba(255, 255, 255, 0);
  padding-left: 25%;

  padding-right: 25%;
}

.contanic {
  padding-top: 80px;
  height: 75vh;
}

.contanic_no_lock {
  padding-top: 80px;
  height: auto;
  min-height: 70vh;
}

.font_div {
  text-align: left;
}

.title_div {
  font-size: 20px;
  font-weight: 600;
  color: #009CD5;
}

.content_div {
  font-size: 17px;
  font-weight: 400;
  color: #666666;
  line-height: 35px;
}

.more_label {
  color: #009CD5;
}

.more_div {
  text-align: right;
  width: 100%;
}

.item_div{
  width: 100%;
  text-align: left;
  padding-top: 20px;
  padding-bottom: 20px;
}
.item_div .left_div{
  width: 90%;
  float: left;
  color: #111111;
  font-weight: 600;
}
.item_div .right_div{
  width: 10%;
  float: left;
  color: #009CD5;
  font-weight: 500;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/view/means.vue